"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ConditionalWrapper = _ref => {
  let {
    children,
    condition,
    WrapperComponent,
    wrapperProps
  } = _ref;
  return condition ? /*#__PURE__*/(0, _jsxRuntime.jsx)(WrapperComponent, {
    ...wrapperProps,
    children: children
  }) : children;
};
ConditionalWrapper.propTypes = {
  children: _propTypes.default.node,
  condition: _propTypes.default.bool,
  WrapperComponent: _propTypes.default.elementType,
  wrapperProps: _propTypes.default.object
};
var _default = exports.default = ConditionalWrapper;